var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 595,
    height: 286,
    viewBox: "0 0 595 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2407_1643)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2407_1643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.645 235.508C156.556 235.508 187.289 210.644 187.289 179.973C187.289 149.301 156.556 124.438 118.645 124.438C80.7333 124.438 50 149.301 50 179.973C50 210.644 80.7333 235.508 118.645 235.508Z",
    fill: "#421563",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2407_1643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.37 216.011C258.39 216.011 299.749 182.551 299.749 141.275C299.749 99.9996 258.39 66.5391 207.37 66.5391C156.351 66.5391 114.992 99.9996 114.992 141.275C114.992 182.551 156.351 216.011 207.37 216.011Z",
    fill: "#421563",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2407_1643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.115 232.557C362.427 232.557 412.941 191.69 412.941 141.279C412.941 90.8668 362.427 50 300.115 50C237.803 50 187.289 90.8668 187.289 141.279C187.289 191.69 237.803 232.557 300.115 232.557Z",
    fill: "#421563",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2407_1643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.62 199.472C452.64 199.472 493.999 166.012 493.999 124.736C493.999 83.4605 452.64 50 401.62 50C350.601 50 309.242 83.4605 309.242 124.736C309.242 166.012 350.601 199.472 401.62 199.472Z",
    fill: "#421563",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2407_1643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.699 146.299C518.56 146.299 544.389 125.403 544.389 99.6262C544.389 73.8494 518.56 52.9531 486.699 52.9531C454.837 52.9531 429.008 73.8494 429.008 99.6262C429.008 125.403 454.837 146.299 486.699 146.299Z",
    fill: "#421563",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2407_1643",
    x: 0,
    y: 74.4375,
    width: 237.289,
    height: 211.07,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_2407_1643"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2407_1643",
    x: 64.9922,
    y: 16.5391,
    width: 284.758,
    height: 249.469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_2407_1643"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2407_1643",
    x: 137.289,
    y: 0,
    width: 325.652,
    height: 282.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_2407_1643"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2407_1643",
    x: 259.242,
    y: 0,
    width: 284.758,
    height: 249.469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_2407_1643"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2407_1643",
    x: 379.008,
    y: 2.95312,
    width: 215.383,
    height: 193.344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_2407_1643"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2407_1643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 595,
    height: 286,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.aefaf34ed1ab71e186fed02fa45d8038.svg";
export { ForwardRef as ReactComponent };